import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=22f2cf33&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&id=22f2cf33&lang=scss&scoped=true&"
import style1 from "./Team.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2cf33",
  null
  
)

export default component.exports